<template>
  <div class="company-detail-page margin-l-20">
    <div class="company-detail-header margin-l-20 margin-r-40">
      <el-date-picker class="margin-l-20" v-model="times" type="month" placeholder="选择月" :clearable="false"
                      format="yyyy-MM" :picker-options="pickerOptions"
                      value-format="yyyy-MM" @change="getCompanyAll"></el-date-picker>
      <!--        <el-cascader v-model="value" :options="options" @change="handleChange" class="areaChoose"></el-cascader>-->
    </div>
    <el-row class="margin-l-20">
    <el-col :span="10" >
      <p class="index-header-title">企业名称</p>
      <el-card style="height: 445px">
        <el-col class="padding-l-40 text-left">
          <h1 class="margin-t-20 margin-b-40" style="color: #333333;font-weight: bold">{{companyInfo.companyname}}</h1>
          <div class="margin-b-20" style="color: #666666">社会统一信用代码：{{companyInfo.keyno}}</div>
          <div class="margin-b-20" style="color: #666666">工商注册号：{{companyInfo.regno}}</div>
          <div class="margin-b-20" style="color: #666666">成立日期：{{companyInfo.startdate}}</div>
          <div class="margin-b-20" style="color: #666666">法定代表人：{{companyInfo.opername}}</div>
          <div class="margin-b-20" style="color: #666666">注册资本：{{companyInfo.registcapi}}</div>
          <div class="margin-b-20" style="color: #666666">注册地址：{{companyInfo.address}}</div>
          <div class="margin-b-20" style="color: #666666;line-height: 30px">住所：{{companyInfo.location}}</div>
          <!--          <div class="margin-b-20">在南昌市排名第18名<span class="margin-l-30">在科技公司排名第18名</span></div>-->
        </el-col>
      </el-card>
    </el-col>
    <el-col :span="14" class="padding-l-30 padding-r-40">
      <p class="index-header-title">企业旗下店铺</p>
      <el-card class="padding-l-10">
        <el-table :data="shopTop" class="colorChang border-DEDEDE" height="405" stripe
                  :default-sort="{prop: 'money', order: 'descending'}" v-loading = "pictLoading"
                  element-loading-background = "rgba(0, 0, 0, 0.5)"
                  element-loading-text = "数据正在加载中"
                  element-loading-spinner = "el-icon-loading">
          <el-table-column type="index" label="排名" width="80px" align="center"></el-table-column>
          <el-table-column prop="storename" label="店铺名称" align="center"></el-table-column>
          <el-table-column prop="platname" label="所属平台" width="180" align="center"></el-table-column>
          <el-table-column prop="salesofmonth" label="当期网络零售额（万元）" align="center"></el-table-column>
          <el-table-column prop="salesofyear" label="累计网络零售额（万元）" align="center"></el-table-column>
        </el-table>
      </el-card>
    </el-col>
    </el-row>
    <el-card class="margin-t-20  margin-l-20 margin-r-40">
      <chart ref="chart4" :options="moneyOptions" autoresize class="width-z100"></chart>
    </el-card>
    <div class="margin-t-20 margin-b-20  margin-l-20 margin-r-40">
      <el-row>
        <el-card>
          <div class=" text-left margin-b-20">
            <span class="index-header-title">企业历史月份销售情况</span>
          </div>
          <el-table :data="monthSalesTop" class="colorChang border-DEDEDE" height="350" stripe
                    :default-sort="{type: 'index', order: 'descending'}" v-loading = "pictLoading"
                    element-loading-background = "rgba(0, 0, 0, 0.5)"
                    element-loading-text = "数据正在加载中"
                    element-loading-spinner = "el-icon-loading">
            <el-table-column prop="times" label="时间" width="80" align="center"></el-table-column>
            <el-table-column prop="sales" label="月销量（万件）"  align="center">
              <template slot-scope="scope">
                {{scope.row.sales || '--'}}
              </template>
            </el-table-column>
            <el-table-column prop="money" label="月销售额（万元）"  align="center"></el-table-column>
            <el-table-column prop="ljSales" label="累计销量（万件）"  align="center">
              <template slot-scope="scope">
                {{scope.row.ljSales || '--'}}
              </template>
            </el-table-column>
            <el-table-column prop="ljMoney" label="累计销售额（万元）"  align="center"></el-table-column>
            <el-table-column prop="salesYoy" label="月销量同比（%）" align="center">
              <template slot-scope="scope">
                {{scope.row.salesYoy || '--'}}
              </template>
            </el-table-column>
            <el-table-column prop="moneyYoy" label="月销售额同比（%）" align="center">
              <template slot-scope="scope">
                {{scope.row.moneyYoy || '--'}}
              </template>
            </el-table-column>
            <el-table-column prop="ljSalesYoy" label="累计销量同比（%）" align="center">
              <template slot-scope="scope">
                {{scope.row.ljSalesYoy || '--'}}
              </template>
            </el-table-column>
            <el-table-column prop="ljMoneyYoy" label="累计销售额同比（%）" align="center"></el-table-column>
          </el-table>
        </el-card>
      </el-row>
    </div>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">注：<br/>
      1、平台范围：天猫商城、京东商城、淘宝网、苏宁易购、国美在线、当当网、亚马逊（中国）、唯品会、拼多多、卷皮网、速卖通、贝贝网、国网商城、环球捕手、融e购、邮乐购、e城e品、供销e家、乐村淘等19个平台；<br/>
      2、更新情况：新纳入唯品会、拼多多、卷皮网、速卖通、贝贝网、国网商城、环球捕手、融e购、邮乐购、e城e品、供销e家、乐村淘等12个平台，包括电商法实施后亮照平台、新监测平台等；<br/>
      3、其他说明  <br/>
      （1）部分已监测平台如食行生鲜、网易严选等为自营平台，无第三方店铺。其他监测和新监测平台后续将分批纳入；  <br/>
      （2）淘宝网企业店铺经营主体信息非公开数据，正在通过其他方式持续补充；拼多多等平台商家公示证照不规范，企业名称识别质量需持续完善。
  </p>
  </div>
</template>

<script>

  export default {
    name: 'company-detail',
    data () {
      return {
        times: '',
        HDIOptions: {}, //企业发展指数雷达图
        id: this.$route.query.id, //获取企业id
        companyInfo: {},//企业信息
        brandList:[],//品牌榜
        moneyOptions: {},//企业近13个月销售额同比图
        goodsTopList: [],//企业热销单品排行榜
        shopOptions: {},//企业名下店铺图表
        shopPieOptions: {},//各店铺占比
        shopTop: [],//企业名下店铺列表
        exponent:{},//指数相关数据
        pictLoading:true,
        monthSalesTop:[],//企业历史月份销售情况
        wholeForm: {type: '1', sMonth: '', eMonth: ''},//整体情况筛选条件

        // numberList:{city:[]}
        items: [
          {type: 'danger', label: 'Top1'},
          {type: 'success', label: 'Top2'},
          {type: 'brand ', label: 'Top3'},
          {type: 'info', label: 'Top4'},
          {type: 'info', label: 'Top5'},
          {type: 'info', label: 'Top6'},
          {type: 'info', label: 'Top7'},
          {type: 'info', label: 'Top8'},
          {type: 'info', label: 'Top9'},
          {type: 'info', label: 'Top10'}
        ],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    http: {
      root: '/',
      headers: {
        token: sessionStorage.getItem("xybdsToken")
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.oneMonth()
      this.getCompanyDetail()
      this.getCompanyTop()
      this.getCompanySales()
    },
    methods: {
      getCompanyAll(){
        this.getCompanyTop()
        this.getCompanyDetail()
      },
      //获取企业销售表格信息
      getCompanySales () {
        if (this.wholeForm.type == '1') {
          this.wholeTitle = '当期网络零售额'
        } else {
          this.wholeTitle = '累计网络零售额'
        }
        this.$http.get(this.header + '/importantCompany/monthSalesTable', {
          params: {
            id: this.id,
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.monthSalesTop = res.data.monthSalesTable.reverse()

          } else {
            this.$alert(res.data.msg)
          }
        })
      },
      //获取企业基本详细信息
      getCompanyDetail () {
        if (this.wholeForm.type == '1') {
          this.wholeTitle = '当期网络零售额'
        } else {
          this.wholeTitle = '累计网络零售额'
        }
        this.$http.get(this.header + '/importantCompany/info', {
          params: {
            times: this.times,
            id: this.id
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.companyInfo = res.data.info
            // this.goodsTopList = res.data.goodsList
            // this.shopTop = res.data.shopList
            // this.brandList = res.data.brandList
            // this.exponent = res.data.comindex
            // if(this.exponent.comIndexShow == null){
            //   this.exponent.comIndexShow = '--'
            // }

            //企业近13个月销售额同比图
            let companyMoneyList = {xTime: [], yTotalMoney: [], simple: [], simpleUnit: []}
            res.data.monthSleslist.forEach((y, index) => {
              companyMoneyList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              companyMoneyList.yTotalMoney.push(yMoney)
              // this.wholeList.yTotalMoney.unit.push('万元')
              companyMoneyList.simple.push(xSimple)
              // this.wholeList.simpleUnit.push('%')
              // return label
            })
            let Min1 = this.calMin(companyMoneyList.yTotalMoney), Min2 = this.calMin(companyMoneyList.simple),
              Max1 = this.calMax(companyMoneyList.yTotalMoney), Max2 = this.calMax(companyMoneyList.simple)
            //企业近13个月销售额同比图
            this.moneyOptions = {
              color: ['#577EC5','#F3B728'],
              title: {//图表标题
                text: '企业' + this.wholeTitle + '变化趋势',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                // trigger: 'axis',
                // axisPointer: {
                //   type: 'cross'
                // },
                formatter: function (e) {
                  // console.dir(e)
                  return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  // '{b}{a}<br/>{c} 万元'
                }
                // formatter: '{a} <br/>{b}: {c} ',
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['销售额', '同比']
              },
              xAxis: {
                type: 'category',
                data: companyMoneyList.xTime,
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '万元',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: Min1,
                  max: Max1,
                  splitNumber: 5,
                  interval: (Max1 - Min1) / 5
                }, {
                  type: 'value',
                  name: '%',
                  // min: 0,
                  // max: 35,
                  // interval: 5,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: Min2,
                  max: Max2,
                  splitNumber: 5,
                  interval: (Max2 - Min2) / 5,
                  axisLabel: {
                    formatter: '{value} %'
                  }
                }],
              series: [{
                name: '销售额',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  emphasis: {
                    color: '#83bff6'
                  }
                },
                data: companyMoneyList.yTotalMoney,
                smooth: true
              }, {
                name: '同比',
                type: 'line',
                yAxisIndex: 1,
                data: companyMoneyList.simple
              }]
            }

          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取企业top信息
      getCompanyTop () {
        if (this.wholeForm.type == '1') {
          this.wholeTitle = '当期网络零售额'
        } else {
          this.wholeTitle = '累计网络零售额'
        }
        this.$http.get(this.header + '/importantCompany/rankInfo', {
          params: {
            times: this.times,
            id: this.id
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.goodsTopList = res.data.goodsList
            this.shopTop = res.data.shopList
            this.brandList = res.data.brandList
            this.pictLoading = false
          } else {
            this.$alert(res.data.msg)
          }
        })
      },

      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
//选择近1个月
      oneMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (let i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          let m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          this.times = dataArr[1]
        } else {
          this.times = dataArr[2]
        }
        // console.dir(dataArr)
      },
    }
  }
</script>

<style>
  .company-detail-page .company-detail-header {
    text-align: left;
    margin-bottom: 8px;
    height: 45px;
    line-height: 45px;
    background: white;
    /*border: 1px solid rgba(100, 156, 238, 0.4);*/
    box-shadow: 0px 6px 7px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    color: #6589C5;
  }

  .company-detail-page .company-detail-header .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 120px;
  }

  .company-detail-page .company-detail-header .el-date-editor input {
    background: white !important;
    width: 115px;
    height: 27px;
    line-height: 27px;
    border: 1px solid rgba(100, 156, 238, 0.4);
  }

  .company-detail-page .company-detail-header .areaChoose input {
    background: rgba(36, 46, 71, 0.3) !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    /*width: 115px;*/
    height: 27px;
    line-height: 27px;
  }
  .company-detail-page .index-header-title{
    /*font-weight: bold;*/
    margin-bottom: 10px;
    margin-top: 10px;
    color: #313131;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/company-detail.vue